import { createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const intVersion = (stringVersion) =>
  stringVersion
    .split('.')
    .reverse()
    .reduce(
      (total, part, index) => total + parseInt(part) * Math.pow(100, index),
      0
    );

const migrations = {
  [intVersion('0.1.0')]: ({ login, ...rest }) => ({
    login: {
      ...login,
      permissions: [],
      menu: [],
      langOptions: []
    },
    ...rest
  })
};

export default {
  key: process.env.REACT_APP_NAME,
  version: intVersion(process.env.REACT_APP_VERSION),
  storage,
  whitelist: ['login', 'i18nState'],
  migrate: createMigrate(migrations, {
    debug: process.env.NODE_ENV !== 'production'
  })
};



// WEBPACK FOOTER //
// ./src/lib/persist.js